import { EnhancedDataGrid } from 'components/enhanced/data-grid';
import { EnhancedDetailPanel } from 'components/enhanced/data-grid/components';
import { useMemo } from 'react';
import { stockQuantityService } from '../api/stock-quantity.service';

export const StockQuantitiesDetail = ({ row, columns }) => {
  const params = useMemo(() => {
    const baseParams: any = {
      product__id: row.product__id,
      exclude_stock: true
    };

    // Aggiunge la proprietà solo se warehouse__id non è null o undefined
    if (row.warehouse__id ?? false) {
      baseParams.warehouse__id = row.warehouse__id;
    }

    return baseParams;
  }, [row.product__id, row.warehouse__id]);

  // Dettaglio: sempre "distinct per location" (come tabella Giacenza lotti), filtrato per product [e opz. warehouse]
  const detailColumns = useMemo(() => {
    return columns.map((col) => ({
      ...col,
      filterable: false,
      sortable: false
    }));
  }, [columns]);

  return (
    <EnhancedDetailPanel>
      <EnhancedDataGrid
        columns={detailColumns}
        service={stockQuantityService}
        getMethod={stockQuantityService.getStockQuantityWithLocation}
        outerParams={params}
      />
    </EnhancedDetailPanel>
  );
};
